/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Laboratorio.ts;
 * Path: ./src/environments/Modules/Laboratorio.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 16/04/25, 17:00;
 * Updated at: 17/04/25, 11:00;
 *
 */

import { Permission } from "src/app/Login/_guards/Permission"
import { ApiPathsService } from "src/app/api-paths.service"
import { CampoAggiuntivo } from "src/app/shared/models/campo-aggiuntivo"
import {FieldViewerComponent} from "../../app/shared/field-viewer/field-viewer.component";
import {copyToClipboardForDocx} from "../Utility/Utility";
import {Progetto} from "../../app/Progetti/Models/Progetto";
import {TipoProgetto} from "../BaseEnvironments/Model";

class LabConfig {
    tasks?: any[]
    filters?: any[]
    Menu?: any[]
    sottoPreventivo?: any[]
    sottoOfferta?: any[]
    Offerta?: any[]
    Impianto?: CampoAggiuntivo[]
}
export function CampiNuovoCliente(): CampoAggiuntivo[]{
  var CampiNuovoCliente: CampoAggiuntivo[] = [
    {...CampoAggiuntivo.TextField("Ragione Sociale *", 'nominativo'), prevDivClass:"col-12", azioni:[
        {
          type:'func',
          icon: 'fas fa-search',
          tooltip:'Cerca la ragione sociale su google',
          func:(x,CampoAggiuntivo, CampoPadre, Padre, apiPaths: ApiPathsService, component)=>{
            window.open(`https://www.google.com/search?q=${x.nuovoCliente.nominativo}`,"_Blank")
          }
        }
      ]
    },
    {...CampoAggiuntivo.TextField("Partita Iva", "piva"), nextDivClass:"col-12", azioni:[
        {
          type:'func',
          icon: 'fas fa-search',
          tooltip:'Compila i dati dalla Partita Iva',
          func:(x,CampoAggiuntivo, CampoPadre, Padre, apiPaths: ApiPathsService, component)=>{
            console.log(x)
            apiPaths.ClassicPost("/progetti/progetti/check/piva", {piva: x.nuovoCliente.piva}).subscribe(data => {
              var datiTrovati = `Attesta: ${data.attesta}\n`;
              datiTrovati += `Ragione Sociale: ${data.ragioneSociale}\n`;
              datiTrovati += `Indirizzo: ${data.indirizzo}\n`;
              datiTrovati += `Città: ${data.citta}\n`;
              datiTrovati += `Provincia: ${data.provincia}\n`;
              datiTrovati += `Cap: ${data.cap}`;

              if(data.valid && confirm(`Ho trovato i seguenti dati.\n${datiTrovati}.\nVuoi procedere con la modifica?`)){
                x.nuovoCliente.nominativo = data.ragioneSociale;
                x.nuovoCliente.indirizzo = data.indirizzo;
                x.nuovoCliente.citta = data.citta;
                x.nuovoCliente.provincia = data.provincia;
                x.nuovoCliente.cap = data.cap;
              }
              if(!data.valid && confirm(`La partita iva ${x.piva} non è valida.`)){

              }
            })
          }
        }
      ]
    },
    {nome:'cliente.referente.nome', required: false, oggetti: ['referenteObject.nome'], class: 'col-lg-3'},
    {nome:'cliente.referente.cognome', required: false, oggetti: ['referenteObject.cognome'], class: 'col-lg-3'},
    {nome:'cliente.referente.telefono', required: false, oggetti: ['referenteObject.telefono'], class: 'col-lg-3'},
    {nome:'Email Referente', required: false, oggetti: ['referenteObject.email'], class: 'col-lg-3'},
    {nome: 'Note', required: false, oggetti: ['note'], inputType:'textarea', class: 'col-lg-12'}
  ];

   var nc:CampoAggiuntivo[] = CampiNuovoCliente.map(x=>{
     return {
      ...x,
      hideif:{func: (x, permission: Permission)=>{ return (!x.clienteObject && permission.isPermitted('gestione-clienti')) || false }},
      oggetti: ["nuovoCliente." + x.oggetti[0]],
      modificabile: true,titleClass: 'control-label col-form-label',
     };
   });

  return nc;
}
export function OffertaLab(): TipoProgetto  {
  return {
    nome: 'Laboratorio',
    id: "L",
    colore: "#1baa03",
    restRoute: "/progetti/progetti",
    hideAziendaStatica:true,
    bottomPageField: [
      {
        modificabile: false,
        hideif: { func: (x) => { return  !x.id || !x.codiceContratto } },
        nome: '',
        oggetti: ['riesameOfferta'],
        type: 'html',
        func: () => {
          return `<br><br><span style=" font-size: larger; font-weight: 600; ">RIESAME DELL'OFFERTA - A CURA DELLA DIREZIONE AZIENDALE  (da redigere in caso di offerta fuori standard o variazioni richieste dal cliente o prezzi inferiori al prezzo di listino)			<br></span>`
        },

        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        prevDivClass: 'col-12',
        modificabile: true,
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        nome: 'Il prezzo è remunerativo?',
        oggetti: ['riesameOfferta'],
        field: ['remunerativo'],
        type: 'object',
        inputType: 'singleDropdown',
        source: [{id:'SI'}, {id:'NO'}],
        internalOutput: `riesameOfferta`,
        OutputField: 'remunerativo',
        placeholder: 'Seleziona',
        class: 'col-md-3',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'id',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
      },
      {
        modificabile: true,
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        nome: 'Eventuali criticità? Eventuali commenti',
        oggetti: ['riesameOfferta'],
        field: ['criticita'],
        type: 'object',
        inputType: 'textarea',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        nome: 'Se è stata riemessa l\'offerta indicare il prot.dell\'offerta precedente.',
        oggetti: ['riesameOfferta'],
        field: ['protocollo'],
        type: 'object',
        inputType: 'text',
        class: 'col-md-3',

      },
      {
        modificabile: true,
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        nome: 'Data Riesame',
        oggetti: ['riesameOfferta'],
        field: ['data'],
        type: 'object',
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: false,
        nome: '',
        oggetti: ['riesameCliente'],
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        type: 'html',
        func: () => {
          return `<br><br><span style=" font-size: larger; font-weight: 600; ">RIESAME DELL'ORDINE DEL CLIENTE - A CURA DELLA DIREZIONE AZIENDALE			</span>`
        },

        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        modificabile: false,
        nome: '',
        oggetti: ['riesameCliente'],
        type: 'html',
        func: () => {
          return `<br><span style=" font-size: larger; font-weight: 600; ">"Il contratto o l'accettazione dell'offerta è cambiata rispetto a quella inviata?
(Se SI, indicare cosa è variato)"					<br></span>`
        },

        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        hideif: { func: (x) => { !x.id || !x.codiceContratto } },
        prevDivClass: 'col-12',
        modificabile: true,
        nome: 'SI/NO',
        oggetti: ['riesameCliente'],
        field: ['sino'],
        type: 'object',
        inputType: 'singleDropdown',
        source: [{ id: 'SI' }, { id: 'NO' }],
        internalOutput: `riesameCliente`,
        OutputField: 'sino',
        placeholder: 'Seleziona',
        class: 'col-md-3',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'id',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
      },
      {
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        modificabile: true,
        nome: 'Nuovo importo accettato (€)',
        oggetti: ['riesameCliente'],
        field: ['importo'],
        type: 'object',
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        modificabile: true,
        nome: 'Motivazioni (es. diminuzione n. di verifiche, sconto aggiuntivo)',
        oggetti: ['riesameCliente'],
        field: ['motivazioni'],
        type: 'object',
        inputType: 'textarea',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        prevDivClass: 'col-12',
        modificabile: true,
        nome: '"Verifica S.p.A. è attualmente in grado di effettuare  i servizi offerti in termini di tempi – costi – qualità e disponibilità del personale - conflitti di interesse -  indicati nel contratto? (se vi sono criticità indicarli)"',
        oggetti: ['riesameCliente'],
        field: ['inGrado'],
        type: 'object',
        inputType: 'singleDropdown',
        source: [{ id: 'SI' }, { id: 'NO' }],
        internalOutput: `riesameCliente`,
        OutputField: 'inGrado',
        placeholder: 'Seleziona',
        class: 'col-md-3',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'id',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
      },
      {
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        modificabile: true,
        nome: 'E\' possibile accettare l\'ordine?',
        oggetti: ['riesameCliente'],
        field: ['accettare'],
        type: 'object',
        inputType: 'singleDropdown',
        source: [{ id: 'SI' }, { id: 'NO' }],
        internalOutput: `riesameCliente`,
        OutputField: 'accettare',
        placeholder: 'Seleziona',
        class: 'col-md-3',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'id',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
      },
      {
        hideif: { func: (x) => { return !x.id || !x.codiceContratto } },
        modificabile: true,
        nome: 'Data Riesame',
        oggetti: ['riesameCliente'],
        field: ['data'],
        type: 'object',
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
    ],

    CampiOfferta: [
      CampoAggiuntivo.SingleDropdown(
        "Azienda",
        "cliente",
        "/anagrafica/clienti/list",
        "nominativo",
        {
          responseHasData:true,
          url:"/anagrafica/clienti/list",
          parameter:[{nome: "page", value: 1}, {nome: "size", value: 10}, {nome: "nome", search: true}],
          azioni:[

            {label: "Copia Informazioni", hideif:{func:(x, permission: Permission)=>{ return x.clienteObject && permission.isPermitted('gestione-clienti') }}, icon:"far fa-copy", func: (Oggetto: Progetto, button, campo, padre, api:ApiPathsService, component: FieldViewerComponent)=>{
             api.ClassicPost("/anagrafica/clienti/get",{id:Oggetto.cliente}).subscribe(cliente=>{
               var string = `${cliente.nominativo}\n${cliente.indirizzo}\n${cliente.cap} ${cliente.citta}\n${cliente.provincia}`;
               const commerciali = cliente?.referenti?.filter(x=>x.repartoObject?.label?.toLowerCase() == 'commerciale');
               if(commerciali?.length)
                 commerciali.forEach(commerciale=>{
                   string += `\n\nAlla c.a. del ${commerciale ? (commerciale['titolo']?? 'Sig.'):'Sig.'} ${commerciale?.nome} ${commerciale?.cognome}\nEmail ${commerciale?.email}\nTel. ${commerciale?.telefono}`;
                 })
               copyToClipboardForDocx(string);
             })
            }},
            {label:"Vai all'anagrafica", hideif:{func:(x, permission: Permission)=>{ return x.clienteObject && permission.isPermitted('gestione-clienti') }}, icon:"far fa-user", func: (Oggetto, button, campo, padre, api:ApiPathsService, component: FieldViewerComponent)=>{
              const url = component.router.serializeUrl(component.router.createUrlTree(['listautenti/formazienda', 'c', Oggetto.clienteObject?.id]));
              const baseHref = document.getElementsByTagName('base')[0]?.getAttribute('href') ?? '/';
              const fullUrl = `${window.location.origin}${baseHref}${url}`;
              window.open(fullUrl, '_blank');
            }}],
          titleClass: 'control-label col-form-label',
        },
        'col-lg-4',
        ()=>true,
        {
          searchPlaceholderText: "Cerca altro",
        }
      ),
      {
        modificabile: true,
        nome: 'Preventivo N:',
        oggetti: ['codice'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        visibleifProhibited: true
      },

      {
        modificabile: true,
        nome: "Revisione",
        oggetti: ['rev'],
        disabledif:{func: (x, permission)=>{return false}},
        hideif: { func: (x) => { return x.rev } },
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
      },
      ...CampiNuovoCliente(),

      {
        modificabile: true,
        nome: 'Compilatore',
        oggetti: ['commerciale'],
        inputType: 'singleDropdown',
        source: 'managers',
        internalOutput: 'commerciale',
        OnFilter: 'filtroCommerciale',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'fullName',
          searchPlaceholderText: "inserire almeno 3 caratteri",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
        },
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      // {
      //   modificabile: true,
      //   nome: 'Oggetto:',
      //   oggetti: ['oggetto'],
      //   inputType: 'text',
      //   titleClass: 'control-label col-form-label',
      //   class: 'col-lg-3',
      //   visibleifProhibited: true
      // },


      {
        modificabile: true,
        nome: 'Offerta.Creazione',
        oggetti: ['data_creazione'],
        disabledif:{func: (x, permission)=>{
            return !x.data_creazione || permission.isOperativeRoles(['AZ','SA']);
          }},
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Offerta',
        oggetti: ['data_emissione'],
        disabledif:{func: (x, permission)=>{
            return !x.data_emissione || permission.isOperativeRoles(['AZ','SA']);
          }},
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Accettazione',
        oggetti: ['data_accettazione'],
        disabledif:{func: (x, permission)=>{
            return !x.data_accettazione || permission.isOperativeRoles(['AZ','SA']);
          }},
        hideif: { func: (x) => { return x.data_emissione } },
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },

      {
        modificabile: true,
        nome: 'Note',
        oggetti: ['note'],
        inputType: 'textarea',
        titleClass: 'control-label col-form-label',
        class: 'col-md-12',
        visibleifProhibited: true
      },
    ],
    CampiSottoOffertaPreventivo: [// se pieno viene gestito preventivo

      {
        sezione: 'Impianto',
        campi: [

          {modificabile: true, nome: 'Città', oggetti: ['provaAcquisto'], field:['citta'], inputType: 'text', titleClass: 'control-label col-form-label', class: 'col-lg-3', type:'object', visibleifProhibited: true},
          { modificabile: true, nome: 'Provincia', oggetti: ['provaAcquisto'], field: ['provincia'], inputType: 'text', titleClass: 'control-label col-form-label', class: 'col-lg-3', type: 'object', visibleifProhibited: true },
          ...(Laboratorio.Impianto),
          {nome:'Attività', oggetti: ['laboratorio'], type:'checkboxArray', class: 'col-lg-12', modificabile: true },
          {modificabile: true, nome: 'Prezzo Laboratorio', oggetti: ['prezzoLab'], inputType: 'number', titleClass: 'control-label col-form-label', class: 'col-lg-3', visibleifProhibited: true},
        ]
      }
    ],
    capacita: [],
    defaultFilter:{tipoProgetto: "L"}
  };
}

export var Laboratorio: LabConfig = {
    sottoPreventivo: [],
    sottoOfferta: [],
    Offerta: [],
    Impianto: [
        {
            nome: 'Tipo Impianto',
            source: '/rma/register/types',
            oggetti: ['provaAcquisto'],
            internalOutput: 'provaAcquisto',
            OutputField: 'brand',
            modificabile: true,
            inputType: 'singleDropdown',
            type: 'object',
            field: ['brandObject'],
            placeholder: 'Seleziona',
            settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'id',
                textField: 'label',
            },
            class: 'col-md-3',
            visibleifProhibited: true
        }
    ],
    tasks: [
        {
            type: 'Z',
            addButton: false,
            restRoute: '/rma/rma',
            hideif: {},
            Label: 'Laboratorio',
            Azioni: [
                {
                    nome: 'Genera Contatori',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'func',
                    func: (task: { id: number, brand, laboratorio: { id: number, numero: string, check: string, risposta: boolean }[], figli: { id: number, attivita: number, attivitaObject: { id: number, check: string, } }[] }, Api: ApiPathsService, OnEnd?: (x) => void) => {
                        Api.ClassicPost("/rma/rma/update", task).subscribe(() => { });
                        console.log("Genera Contatori", { task, Api });
                        task.laboratorio?.filter(laboratorio => laboratorio?.risposta)?.forEach(laboratorio => {
                            var contatoriCreati = task?.figli?.filter(figli => figli?.attivitaObject?.id == laboratorio.id)?.length ?? 0;
                            var contatoriPattuiti = parseInt(laboratorio.numero?.toString() ?? '0')
                            var contatoriDaGenerare = contatoriPattuiti - contatoriCreati;
                            if (contatoriDaGenerare <= 0)
                                return;
                            for (let index = 0; index < contatoriDaGenerare; index++) {
                                Api.ClassicPost('/rma/contatore/add', { padre: task.id, brand: task.brand, nome: 'Nuovo Contatore', alert_inizio_task: 0, alert_fine_task: 0, attivita: laboratorio.id }).subscribe(x => {
                                    console.log(x);
                                })
                            }

                        })

                        setTimeout(() => {
                            OnEnd?.(task);
                        }, 1500);

                    },
                    icon: 'fas fa-retweet text-info',
                    placeholder: 'Genera Contatori',
                },
                // { nome: 'Aggiungi Contatore', close: false, class: ' btn ', labelClass: 'ml-1 text-info font-weight-bold', type: 'POST', restRoute: '/rma/contatore/add', icon: 'fas fa-plus-circle text-info', placeholder: 'Aggiungi Contatore', parameter: [{nome: 'brand', parameter: 'brand'},{ nome: "padre", parameter: 'id' }, { nome: "nome", value: 'Nuovo Contatore' }, { nome: "alert_inizio_task", value: '0' }, { nome: "alert_fine_task", value: '0' }] },
            /* {nome: 'Elimina',close:true, class:' btn ',  labelClass:'ml-1 text-danger font-weight-bold', type: 'POST', restRoute: '/task/rma/delete', preAlert: 'Sei sicuro di voler eliminare questo elemento?', capacita: ['gestione-news'], icon:'fas fa-trash text-danger', placeholder: 'Elimina', successMex: 'Elemento eliminato con successo', parameter: [{nome:"id", parameter: 'id'}]},
            */],
            Buttons: [
                {
                    nome: 'Vai alle Commesse',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/Z/DA',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x, permissions: Permission) => {
                            return x.stato == 'DP' && permissions?.HasnotCapacity(['tecnico']);
                        }
                    },
                },
                {
                    nome: 'Vai ai Contatori',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/WL/DPL',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x) => {
                            return x.stato == 'DA';
                        }
                    },
                },
                {
                    nome: 'Vai ai Contatori',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/WL/CAL',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x) => {
                            return x.stato == 'CA';
                        }
                    },
                },
                {
                    nome: 'Vai alle Commesse',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/Z/ICB',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x, permissions: Permission) => {
                            return x.stato == 'IC' && permissions?.HasnotCapacity(['tecnico']);
                        }
                    },
                },
                {
                    nome: 'Vai ai Contatori',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/WL/ICL',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x) => {
                            return x.stato == 'ICB';
                        }
                    },
                },

            ],
            sezioni: [
                {
                    sezione: 'Scheda Cliente',
                    campo: 'clienteObject',
                    campi: [
                        { nome: 'Cliente:', oggetti: ['nominativo'], field: ['nominativo'], class: 'col-lg-11', inputClass: 'ml-3' },
                        { nome: 'Tel:', oggetti: ['telefono'], field: ['telefono'], class: 'col-lg-2', inputClass: 'ml-3' },
                        { nome: 'Email:', oggetti: ['email'], field: ['email'], class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Pec:', oggetti: ['pec'], field: ['pec'], class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Indirizzo:', oggetti: ['indirizzo'], field: ['indirizzo'], class: 'col-lg-11', inputClass: 'ml-3' },
                        { nome: 'Referente:', oggetti: ['referenti'], type: "object", field: ['fullName'], class: 'col-lg-5', inputClass: 'ml-3' },
                        { nome: '', oggetti: ['referenti'], type: "object", field: ['telefono'], class: 'col-lg-6', inputClass: 'ml-3' },
                        { nome: 'Comune:', oggetti: ['citta'], class: 'col-lg-9', inputClass: 'ml-3' },
                        { nome: 'Provincia:', oggetti: ['provincia'], class: 'col-lg-3', inputClass: 'ml-3' },
                    ]
                },
                {
                    sezione: 'Commessa',
                    campi: [
                        { nome: 'Esercente:', oggetti: ['commessaObject'], field: ['consegna', 'nominativo'], type: 'object', class: 'col-lg-12', inputClass: 'ml-3' },
                        { nome: 'Referente Impresa:', oggetti: ['commessaObject'], field: ['referente', 'nominativo'], type: 'object', class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Tel Referente:', oggetti: ['commessaObject'], field: ['referente', 'telefono'], type: 'object', class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Email Referente:', oggetti: ['commessaObject'], field: ['referente', 'email'], type: 'object', class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Mansione Referente:', oggetti: ['commessaObject'], field: ['referente', 'mansione'], type: 'object', class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Attività Impresa:', oggetti: ['commessaObject'], field: ['oggetto'], class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Tipo Impianto:', oggetti: ['brandObject'], field: ['label'], class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Protocollo:', oggetti: ['protocollo'], class: 'col-12', inputClass: 'ml-3' },
                        { nome: 'Data apertura:', oggetti: ['contrattoObject'], field: ['data_creazione'], inputType: 'date', class: 'col-lg-4', inputClass: 'ml-3' },
                        { nome: 'Importo Contabilizzato:', oggetti: ['contabilizzato'], class: 'col-lg-4', inputClass: 'ml-3', inputType: 'euro' },
                        { nome: 'Acconti Pagati:', oggetti: ['accontoPagato'], class: 'col-lg-4', inputClass: 'ml-3', inputType: 'euro' },
                        { nome: 'Ubicazione Impianto:', oggetti: ['acquirente', 'acquirente', 'acquirente', 'acquirente'], field: ['indirizzo', 'cap', 'citta', 'provincia'], class: 'col-lg-12', inputClass: 'ml-3' },
                        { nome: "Latitudine:", oggetti: ['acquirente'], field: ['lat'], type: 'object', inputType: 'number', modificabile: true, class: 'col-lg-3', warning: 'Attenzione il campo Latitudine non è stato compilato!' },
                        { nome: "Longitudine:", oggetti: ['acquirente'], field: ['lon'], type: 'object', inputType: 'number', modificabile: true, class: 'col-lg-3', warning: 'Attenzione il campo Longitudine non è stato compilato!' },
                    ]
                },
                {
                    sezione: 'Programmazione Attività',
                    campi: [
                        { nome: 'Prima Verifica Entro:', oggetti: ['data_inizio_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3', warning: true },
                        { nome: 'Data Appuntamento:', oggetti: ['data_fine_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3', warning: true },
                        { nome: 'Straordinaria:', oggetti: ['straordinario'], type: 'boolean', inputType: 'checkbox', modificabile: true, class: 'col-lg-2' },
                        { nome: 'Commessa DPR/462:', oggetti: ['accreditato'], type: 'boolean', inputType: 'checkbox', modificabile: true, class: 'col-lg-2' },
                        { nome: 'Rinnovo Automatico:', oggetti: ['rinnovo'], type: 'boolean', inputType: 'checkbox', modificabile: true, class: 'col-lg-2' },
                        { nome: 'Note:', oggetti: ['note'], inputType: 'textarea', modificabile: true, class: 'col-lg-12' },
                        // { nome: "Riferimento dell'offerta:", inputType: 'textarea', type: 'object', oggetti: ['commessaObject'], field: ['codiceContratto'], modificabile: false, class: 'col-lg-4', warning: true },
                        { nome: 'Preventivo €:', oggetti: ['prezzoLab'], modificabile: true, inputType: 'number', class: 'col-lg-4', warning: true },
                        { nome: "Note dell'Ispettore:", oggetti: ['noteIspettore'], inputType: 'textarea', modificabile: true, class: 'col-lg-3' },
                        { nome: 'Attivitá di Laboratorio', oggetti: ['laboratorio'], type: 'checkboxArray', class: 'col-lg-12', modificabile: true },
                    ]
                },
                {
                    sezione: 'Riesame rapporti di ispezione',
                    campi: [
                        { nome: 'Chiusura Commessa:', oggetti: ['data_inizio_effettiva'], inputType: 'date', modificabile: true, class: 'col-lg-4', warning: true },
                        { nome: 'Emissione Certificato:', oggetti: ['data_fine_effettiva'], inputType: 'date', modificabile: true, class: 'col-lg-4', warning: true },
                        { nome: 'Firmato', oggetti: ['chiuso'], type: 'boolean', inputType: 'checkbox', modificabile: true, class: 'col-lg-3', warning: true },
                        { nome: 'Lavorata', oggetti: ['chkProcedura'], type: 'boolean', inputType: 'checkbox', modificabile: true, class: 'col-lg-3' },
                        { nome: 'Da chiudere', oggetti: ['chiuso'], type: 'boolean',inputType: 'checkbox', modificabile: true, class: 'col-lg-3' },


                    ]
                },
                {
                    sezione: '',
                    campi: [
                        { nome: "Files", type: "Files", url: "/rma/rma/file", class: 'col-lg-12', OnChange: 'OnFilesChange', GestioneFile: true, modificabile: true },
                        {
                            nome: 'Contatori',
                            oggetti: ['cotatori'],
                            type: "table",
                            tasktype: "WL",
                            hideif: { fieldnotexist: 'id' },
                            header: [
                                { nome: "Contatore", oggetti: ['nome'], style: { 'margin-left': '10px' }, },
                                { nome: "Attività", oggetti: ['attivitaObject'], field:['check'], type:'object', style: { 'margin-left': '10px' }, },
                                { nome: "Tecnico", oggetti: ['managerObject'], field:['fullName'], type:'object', style: { 'margin-left': '10px' }, },
                            ],
                            source: "/rma/contatore/list",
                            parameter: [{ nome: "page", value: 0 }, { nome: "size", value: 200 }, { nome: "padre", parameter: "id" }],
                            responseHasData: true,
                            modificabile: true,
                            class: 'col-lg-12',
                            azioni: [
                                { ExternalOnClick: 'OnTableEdit', icon: ' fas fa-pencil-alt', tooltip: 'Edit', color: 'blue' },
                            ]
                        },
                    ]
                }
            ],
        },
        {
            Headers: [
                { nome: 'Attività', oggetti: ['attivitaObject.check', 'codiceCommessa'], inputType: 'text' },
                { nome: 'Stato', oggetti: ['statoObject.label'], inputType: 'text' },
                { nome: 'Esercente', oggetti: ['esercente'], inputType: 'text' },
                { nome: 'Referente', oggetti: ['referente'], inputType: 'text' },
                { nome: 'Tel. Referente', oggetti: ['referenteTel'], inputType: 'text' },
                { nome: 'Matricola', oggetti: ['matricola'], inputType: 'text' },
                { nome: 'Indirizzo', oggetti: ['indirizzo', 'cap', 'citta', 'provincia'], inputType: 'text' },
                { nome: 'Data Impegno', oggetti: ['data_inizio_prevista'], inputType: 'date' },
                { nome: 'Ispettore', oggetti: ['managerObject'], field: ['fullName'], type: 'object', inputType: 'text' },
                // Attività, Esercente, Referente, Tel Referente, matricola, indirizzo(concatenazione di indirizzo, cap città provincia), Data Impegno(data_inizio_prevista, da aggiungere anche nella maschera del contatore), Ispettore

            ],
            type: 'WL',
            addButton: false,
            restRoute: '/rma/contatore',
            managerLoggato: {func: (x, permissions: Permission) => {
                return false;
            }},
            hideif: {},
            Label: 'Contatore',
            Azioni: [
                { nome: 'Elimina', close: true, class: ' btn ', labelClass: 'ml-1 text-danger font-weight-bold', type: 'POST', restRoute: '/rma/contatore/delete', preAlert: 'Sei sicuro di voler eliminare questo elemento?', capacita: ['gestione-news'], icon: 'fas fa-trash text-danger', placeholder: 'Elimina', successMex: 'Elemento eliminato con successo', parameter: [{ nome: "id", parameter: 'id' }] },
            ],
            Buttons: [
                {
                    nome: 'Vai alle Commesse',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/Z/CA',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x, permissions: Permission) => {
                            return x.stato == 'CAL' && permissions?.HasnotCapacity(['tecnico']);
                        }
                    },
                },
                {
                    nome: 'Vai alle Commesse',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/Z/DA',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x, permissions: Permission) => {
                            return x.stato == 'DPL' && permissions?.HasnotCapacity(['tecnico']);
                        }
                    },
                },
                {
                    nome: 'Vai ai Contatori',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/WL/DPL',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x) => {
                            return x.stato == 'DA';
                        }
                    },
                },
                {
                    nome: 'Vai alle Commesse',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/Z/ICB',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x, permissions: Permission) => {
                            return x.stato == 'ICL' && permissions?.HasnotCapacity(['tecnico']);
                        }
                    },
                },
                {
                    nome: 'Vai ai Contatori',
                    close: false,
                    class: ' btn ',
                    labelClass: 'ml-1 text-info font-weight-bold',
                    type: 'GOTO',
                    restRoute: '/task/list/WL/ICL',
                    icon: 'fas fa-chevron-right text-info',
                    placeholder: '',
                    hideif: {
                        func: (x) => {
                            return x.stato == 'ICB';
                        }
                    },
                },

            ],
            campi: [
                { nome: 'Nome :', oggetti: ['nome'], modificabile: true, inputType: 'text', class: 'col-lg-3', warning: true },
                { nome: 'Costruttore :', oggetti: ['costruttore'], modificabile: true, inputType: 'text', class: 'col-lg-3', warning: true },
                { nome: 'Modello :', oggetti: ['modello'], modificabile: true, inputType: 'text', class: 'col-lg-3', warning: true },
                { nome: 'Matricola :', oggetti: ['matricola'], modificabile: true, inputType: 'text', class: 'col-lg-3', warning: true },
                { nome: 'Longitudine :', oggetti: ['lat'], modificabile: true, inputType: 'text', class: 'col-lg-3', warning: true },
                { nome: 'Latitiudine :', oggetti: ['lon'], modificabile: true, inputType: 'text', class: 'col-lg-3', warning: true },
                CampoAggiuntivo.SingleDropdown('Tipo Impianto: ', 'brand', '/rma/register/types', 'label'),
                CampoAggiuntivo.ObjectTextField('Attività: ', 'attivitaObject', 'check',false),
                //CampoAggiuntivo.SingleDropdown('Attività', 'attivita', 'Attivita', 'check', {}),
                { nome: 'Note :', oggetti: ['note'], modificabile: true, inputType: 'textarea', class: 'col-lg-12', warning: true },
                CampoAggiuntivo.TextField('Indirizzo :', 'indirizzo'),
                CampoAggiuntivo.TextField('Cap :', 'cap'),
                CampoAggiuntivo.TextField('Città :', 'citta'),
                CampoAggiuntivo.TextField('Provincia :', 'provincia'),

                { nome: 'Data Impegno', oggetti: ['data_inizio_prevista'], inputType: 'datetime-local', modificabile: true, class: 'col-lg-3' },
                { nome: 'Data chiusura', oggetti: ['data_fine_prevista'], inputType: 'datetime-local', modificabile: true, class: 'col-lg-3' },
                CampoAggiuntivo.SingleDropdown('Ispettore', 'manager', '/anagrafica/persone/list', 'fullName', {
                    parameter: [{ nome: 'page', value: 0 }, { nome: 'size', value: 200 }, {
                        nome: 'checks', func: (x, padre) => {
                            return x.attivita ? [x.attivita] : [];
                        }
                    }],
                    url: '/anagrafica/persone/list',
                    responseHasData: true,
                    warning: true
                }),
                {
                    modificabile: true,
                    nome: 'Stato',
                    oggetti: ['stato'],
                    inputType: 'singleDropdown',
                    source: '/rma/contatore/stati',
                    internalOutput: 'statoObject',
                    OutputField: 'stato',
                    placeholder: 'Seleziona',
                    settings: {
                        singleSelection: true,
                        closeDropDownOnSelection: true,
                        singleOutput: true,
                        idField: 'id',
                        textField: 'label',
                        allowSearchFilter: false,
                        allowRemoteDataSearch: true,
                    },
                    class: 'col-lg-3',
                    visibleifProhibited: true,
                    warning: false
                },
                { nome: "Files Commessa", type: "Files", url: "/rma/rma/file", oggetti: ['commessaObject'], modificabile: true, class: 'col-lg-12', OnChange: 'OnFilesChange', GestioneFile: false,},
                { nome: "Files", type: "Files", url: "/rma/contatore/file", attr: { types: [{ label: 'Documenti Cliente', id: 'doc' }, { label: 'Foto', id: 'pic' }, { label: 'Certificati', id: 'cert' }] }, class: 'col-lg-12', OnChange: 'OnFilesChange', GestioneFile: true, modificabile: true }
            ]
        }
    ],
    filters: [
        {
            id: "Z", label: "Commesse", capacita: [], tipo: "Z", module: "Rma", SubFilter: [
                { id: "DAP", label: "Da Aprire", capacita: [], module: undefined },
                { id: "DP", label: "Da pianificare", capacita: [], module: undefined },//contratti
                { id: "DA", label: "Da pianificare", capacita: [], module: undefined },//commesse
                { id: "IC", label: "In corso", capacita: [], module: undefined, },//contratti
                { id: "ICB", label: "In corso", capacita: [], module: undefined, },//commesse
                { id: "CA", label: "Da chiudere", capacita: [], module: undefined },
                { id: "DF", label: "Da Fatturare", capacita: [], module: undefined },
                { id: "F", label: "Da Incassare", capacita: [], module: undefined },
                { id: "TT", label: "Tutte", capacita: [], module: undefined },
            ]
        },
        {
            id: "WL", label: "Contatori", capacita: [], tipo: "W", module: "Rma", SubFilter: [
                { id: "DAP", label: "Da Aprire", capacita: [], module: undefined },
                { id: "DPL", label: "Da pianificare", capacita: [], module: undefined },//contratti
                { id: "DA", label: "Da pianificare", capacita: [], module: undefined },//commesse
                { id: "ICL", label: "In corso", capacita: [], module: undefined, },//contratti
                { id: "ICB", label: "In corso", capacita: [], module: undefined, },//commesse
                { id: "CAL", label: "Da chiudere", capacita: [], module: undefined },
                { id: "DF", label: "Da Fatturare", capacita: [], module: undefined },
                { id: "F", label: "Da Incassare", capacita: [], module: undefined },
                { id: "TT", label: "Tutte", capacita: [], module: undefined },
            ]
        },
    ],
    Menu: [
        {
            module: "Rma",
            title: 'Commesse Lab',
            icon: "mdi mdi-calendar-multiple-check",//mdi-calendar-multiple-check //mdi-engine-outline
            class: "has-arrow",
            submenu: [
                {
                    module: "Rma",
                    path: "task/list/Z/DAP",
                    title: 'Da Aprire',
                    icon: "mdi mdi-calendar",
                    capacita: ["menu-commesse-lab-daaprire"]
                },
                {
                    module: "Rma",
                    path: "task/list/WL/DPL",
                    title: 'Da pianificare',
                    icon: "mdi mdi-calendar",
                    capacita: ["menu-commesse-lab-dapianificare"]
                },
                // {
                //   module: "Rma",
                //   path: "task/list/Z/DA",
                //   title: 'Da approvare',
                //   icon: "mdi mdi-calendar",
                //   capacita: ["menu-commesse-daapprovare"]
                // },

                {
                    module: "Rma",
                    path: "task/list/WL/ICL",
                    title: 'In corso',
                    icon: "mdi mdi-calendar",
                    capacita: ["menu-commesse-lab-incorso"]
                },

                {
                    module: "Rma",
                    path: "task/list/WL/CAL",
                    title: 'Da Chiudere',
                    icon: "mdi mdi-calendar",
                    capacita: ["menu-commesse-lab-chiuse"]
                },
                {
                    module: "Rma",
                    path: "task/list/Z/DF",
                    title: 'Da Fatturare',
                    icon: "mdi mdi-calendar",
                    capacita: ["menu-fatture-lab"]
                },
                {
                    module: "Rma",
                    path: "task/list/Z/F",
                    title: 'Da Incassare',
                    icon: "mdi mdi-calendar",
                    capacita: ["menu-fatture-lab"]
                },
                {
                    module: "Rma",
                    path: "task/list/Z/TT",
                    title: 'Tutte',
                    icon: "mdi mdi-calendar",
                    capacita: ["menu-commesse-lab-tutte"]
                },
            ],
            capacita: [
                "menu-commesse-lab-tutte",
                "menu-commesse-lab-daaprire",
                "menu-commesse-lab-dapianificare",
                "menu-commesse-lab-daapprovare",
                "menu-commesse-lab-daaccettare",
                "menu-commesse-lab-incorso",
                "menu-commesse-lab-dachiudere",
                "menu-commesse-lab-bloccate",
                "menu-commesse-lab-chiuse",
                "menu-fatture-lab"
            ]
        },
    ]
};

